import './ErrorScreen.css';

interface ErrorScreenProps {
  title?: string;
  message: string;
}

export default function ErrorScreen({
  title = 'Unavailable',
  message,
}: ErrorScreenProps) {
  return (
    <div className="error-screen">
      <div className="error-screen__content">
        <div className="error-screen__icon">⚠️</div>
        <h1 className="error-screen__title">{title}</h1>
        <p className="error-screen__message">{message}</p>
        <p className="error-screen__subtext">This showcase is unavailable</p>
      </div>
    </div>
  );
}
